// 261030 C1 — plan layout four gen video ở bước ④ (có hộp giá); mọi nút gọi `genEvent` / `genEvents` / `regenerateClip` / `editClip` của giao diện cũ phải ẨN. CHỈ logic thuần.
/** Chữ thay cho nút gen cũ. */
export const LAYOUT_FOUR_GEN_HINT = 'Plan này dùng khung 4 bước — gen video ở bước 4 (nút «Gen N video»), không gen ở đây.';
/** Plan có `workflowLayout === 'four'`? Ưu tiên plan của context (đúng id) rồi bản đọc riêng; chưa biết ⇒ false (BE vẫn chặn bằng 409 LAYOUT_FOUR_USE_VIDEO_ROUTES). */
export function isLayoutFourPlan(planId: string, ctxPlan: { id?: string; workflowLayout?: string | null } | null | undefined, fetched: string | null | undefined): boolean {
  if (ctxPlan && ctxPlan.id === planId) return ctxPlan.workflowLayout === 'four';
  return fetched === 'four';
}
